var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "spinner", style: _vm.styles }, [
    _c("div", { staticClass: "blob top", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob bottom", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob left", style: _vm.blobStyles }),
    _vm._v(" "),
    _c("div", { staticClass: "blob move-blob", style: _vm.moveBlobStyles }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }